import React, { useCallback, useState, useEffect } from "react";
import uploadIcon from "../asses/img/icon-upload.png";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import { validateInvoiceFile } from "./validateInvoicePdf";

const TOAST_ID_UPLOAD_INVOICE_ERROR = "upload-invoice-error";

const showUploadInvoiceError = (message) => {
  toast.dismiss(TOAST_ID_UPLOAD_INVOICE_ERROR);
  toast(
    <div className="invoice-toast-error-inner">
      <span className="invoice-toast-error-icon" aria-hidden>
        !
      </span>
      <span className="invoice-toast-error-text">{message}</span>
    </div>,
    {
      className: "invoice-toast-error",
      bodyClassName: "invoice-toast-error-body",
      toastId: TOAST_ID_UPLOAD_INVOICE_ERROR,
      containerId: "invoice-change-toast",
      type: "default",
    }
  );
};

const onDropRejected = () => {
  showUploadInvoiceError("No pudimos cargar el (los) archivo(s)...");
};

const UploadElectronicInvoiceFile = ({ value, onChange, onMeta, isNameEmpty }) => {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    let timer;

    if (!isNameEmpty || isNameEmpty.length === 0) {
      setShowLoading(true);
      timer = setTimeout(() => setShowLoading(false), 1500);
    } else {
      setShowLoading(false);
    }

    return () => clearTimeout(timer);
  }, [isNameEmpty]);

  const onDropAccepted = useCallback(
    async (acceptedFiles) => {
      const files = acceptedFiles.map((file) => file);
      const first = files?.[0];
      const result = await validateInvoiceFile(first);
      if (!result.ok) {
        showUploadInvoiceError(result.reasons?.[0] || "Archivo inválido");
        onChange?.(null);
        onMeta?.(null);
        return;
      }

      onChange?.(files);
      onMeta?.(result.meta ?? null);
    },
    [onChange, onMeta]
  );

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    onDropAccepted,
    onDropRejected,
    accept: "application/pdf,image/jpeg,image/png,image/webp,image/gif"
  });

  const currentFiles = (value?.length ? value : acceptedFiles) ?? [];
  const archivos = currentFiles.map((archivo) => (
    <p
      className="mb-0 upload-electronic-invoice-file-name"
      style={{ fontSize: "12px", color: "#668F0F" }}
      key={archivo.lastModified}
      title={archivo.name}
    >
      {archivo.name}
    </p>
  ));

  return (
    <div {...getRootProps()} className="dropzone upload-electronic-invoice-dropzone">
      <input {...getInputProps()} />

      {showLoading ? (
        <div className="container-sniper"></div>
      ) : (
        <label className="upload-btn upload-electronic-invoice-upload-btn">
          <div
            className="d-flex align-items-center upload-electronic-invoice-inner"
            style={{ fontSize: "12px", gap: "7px" }}
          >
            <img className="upload-electronic-invoice-icon" src={uploadIcon} alt="Adjuntar Factura" />
            {archivos.length > 0 ? archivos : "Adjuntar Factura que desea cambiar"}
          </div>
        </label>
      )}
    </div>
  );
};

export default UploadElectronicInvoiceFile;